import { render, staticRenderFns } from "./KDataTable.vue?vue&type=template&id=ca3973f0&"
import script from "./KDataTable.vue?vue&type=script&lang=js&"
export * from "./KDataTable.vue?vue&type=script&lang=js&"
import style0 from "./KDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports